import * as React from 'react';
import { ImgHTMLAttributes } from 'react';
import * as TypeStyle from 'typestyle';
import { Messages } from '../../gen-src/Localize';
import { FormatterType } from '../widgets/TextFormatter/MarkupHelpers';
import { encodeSvg } from './Icons';
import { BoldSvg, H1Svg, H2Svg, H3Svg, ItalicSvg, LinkSvg, OLSvg, ParagraphSvg, ULSvg, UnderlineSvg } from './resources/TextFormatterSvgs';

const ImgSrcMap: { [key in FormatterType]: string } = {
  Bold: encodeSvg(BoldSvg()),
  Heading1: encodeSvg(H1Svg()),
  Heading2: encodeSvg(H2Svg()),
  Heading3: encodeSvg(H3Svg()),
  Italic: encodeSvg(ItalicSvg()),
  Link: encodeSvg(LinkSvg()),
  OrderedList: encodeSvg(OLSvg()),
  Paragraph: encodeSvg(ParagraphSvg()),
  Underline: encodeSvg(UnderlineSvg()),
  UnorderedList: encodeSvg(ULSvg()),
};

const IconStyleName: string = TypeStyle.style({
  height: 14,
  width: 14,
});

export const TextFormatterNames: { [key in FormatterType]: () => string } = {
  Bold: () => Messages.bold(),
  Heading1: () => Messages.heading1(),
  Heading2: () => Messages.heading2(),
  Heading3: () => Messages.heading3(),
  Italic: () => Messages.italics(),
  Link: () => Messages.link(),
  OrderedList: () => Messages.orderedList(),
  Paragraph: () => Messages.paragraph(),
  Underline: () => Messages.underline(),
  UnorderedList: () => Messages.unorderedList(),
};

export const TextFormatterIcon: React.FC<{ type: FormatterType } & ImgHTMLAttributes<HTMLImageElement>> = props =>
  <img
    alt={TextFormatterNames[props.type]()}
    className={TypeStyle.classes(props.className, IconStyleName)}
    key={`${props.type}_textileIcon`}
    src={ImgSrcMap[props.type]}
  />;
